import { Box } from '@mui/material';

const ClusterPlaneIconColor = ({
  color,
  rotate = 0,
  boxSx = {},
  svgSx = {},
  id,
}) => (
  <Box
    id={id} // 👈 el id se aplica acá y funciona perfecto
    sx={{
      width: 20,
      height: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...boxSx,
    }}
  >
    <Box
      component="svg"
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        transform: `rotate(${rotate}deg)`,
        transformOrigin: 'center',
        width: 20,
        height: 20,
        ...svgSx, // 👈 paddings/posicion ahora van acá
      }}
    >
      <path
        d="M8.3 19.48L13 11.5H18.5C19.33 11.5 20 10.83 20 10C20 9.17 19.33 8.5 18.5 8.5H13L8.3 0.52C8.12 0.2 7.77 0 7.4 0C6.7 0 6.2 0.67 6.39 1.34L8.49 8.5H3L1.65 6.24C1.56 6.09 1.39 6 1.22 6H0.639999C0.309999 6 0.0699997 6.31 0.15 6.62L0.879999 9.54L1 10L0.91 10.38L0.799999 10.8L0.32 12.7L0.15 13.37C0.0699997 13.69 0.309999 13.99 0.639999 13.99H1.22C1.4 13.99 1.56 13.9 1.65 13.75L3 11.5H8.5L6.4 18.66C6.2 19.33 6.7 20 7.4 20C7.77 20 8.12 19.8 8.3 19.48Z"
        fill={color}
      />
    </Box>
  </Box>
);

export default ClusterPlaneIconColor;
